import React from 'react';
import { useLocation } from 'react-router-dom';
import { HiOutlineChartBarSquare, HiOutlineClock, HiOutlineCurrencyPound, HiOutlineKey, HiOutlineShieldCheck, HiOutlineLockClosed } from 'react-icons/hi2';
import '../../styles/auth.css';

const PANELS = {
  '/signin': {
    heading: ['Run your shifts.', 'Pay your team.'],
    desc: 'A faster way to track who worked, when they worked, and what they earned — all in one place.',
    features: [
      { icon: <HiOutlineChartBarSquare />, t: 'Real-time team dashboard' },
      { icon: <HiOutlineClock />, t: 'Shift tracking & scheduling' },
      { icon: <HiOutlineCurrencyPound />, t: 'Automated weekly payroll' }
    ]
  },
  '/forgot-password': {
    heading: ['Forgot your', 'password?'],
    desc: "We'll email a 6-digit code to verify it's really you. Takes about a minute.",
    features: [
      { icon: <HiOutlineKey />, t: 'Email-verified reset' },
      { icon: <HiOutlineShieldCheck />, t: 'Secure & encrypted' },
      { icon: <HiOutlineLockClosed />, t: 'Set a new password' }
    ]
  }
};

const AuthLayout = ({ children }) => {
  const loc = useLocation();
  const panel = PANELS[loc.pathname] || PANELS['/signin'];

  return (
    <div className="auth-page">
      <div className="auth-brand-panel">
        <div className="auth-brand-logo">
          <div className="auth-brand-logo-mark">RM</div>
          <div className="auth-brand-logo-name">Restaurant Manager</div>
        </div>

        <div className="auth-brand-content">
          <h1>
            {panel.heading[0]}<br />
            <span className="accent">{panel.heading[1]}</span>
          </h1>
          <p>{panel.desc}</p>
          <div className="auth-brand-features">
            {panel.features.map((f, i) => (
              <div className="auth-brand-feature" key={i}>
                <div className="auth-brand-feature-icon">{f.icon}</div>
                <span>{f.t}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="auth-brand-foot">© Restaurant Manager · Built for hospitality</div>
      </div>

      <div className="auth-form-panel">
        <div className="auth-form-wrap">
          <div className="auth-mobile-logo">
            <div className="auth-mobile-logo-mark">RM</div>
            <div className="auth-mobile-logo-name">Restaurant Manager</div>
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
